export default __webpack_public_path__ + "static/media/logo-small.93653419.png";